import { idOrLegacyId } from '../../entities/properties/selectors';
import { IState } from '../../store/reducer';

export const listingsForProperty = (propertyId: string | number, state: IState) => {
	const lookupId = idOrLegacyId(propertyId);
	return state.entities.listings.byPropertyId[lookupId];
};
